var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeBean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93677 4.00049C4.15652 4.44173 2 7.61945 2 11.474C2 14.3619 3.21056 16.8699 4.98701 18.1318C5.33061 17.7544 5.66474 17.3544 5.97346 16.9349C7.26115 15.1854 7.9939 13.255 7.32219 11.2993C6.20516 8.04718 6.25569 5.59511 6.93677 4.00049Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3811 18.8209C6.77371 18.938 7.18183 18.9998 7.6007 18.9998C10.6939 18.9998 13.2014 15.6304 13.2014 11.474C13.2014 7.77877 11.2195 4.70559 8.60608 4.06909C7.94842 5.02063 7.47489 7.12634 8.74084 10.8121C9.64881 13.4556 8.58646 15.9152 7.18152 17.8241C6.92704 18.1698 6.65762 18.5027 6.3811 18.8209Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 9.41083C19.9341 9.17324 17.5645 9.70224 14.7013 11.4609C14.6992 9.66756 14.2887 7.96964 13.5569 6.5374C17.1709 5.83542 20.5526 7.05245 21.6406 9.41083Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7737 17.1926C14.7892 17.4413 13.8134 17.546 12.8872 17.5222C13.7299 16.33 14.3122 14.8646 14.5629 13.2654C14.8104 13.15 15.0554 13.0167 15.2973 12.8641C18.6332 10.7593 20.8629 10.6504 21.9998 11.0193C22.0181 13.6313 19.4545 16.2624 15.7737 17.1926Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeBean);
export default __webpack_public_path__ + "static/media/coffee-bean.6da2607d3d089d83f45504bfa185a3e4.svg";
export { ForwardRef as ReactComponent };